<template>
  <div>
    <!-- 头部四小块 -->
    <a-row :gutter="24">
      <a-col
        :sm="24"
        :md="12"
        :xl="6"
        :style="{ marginBottom: '24px' }"
        @click="HrefRoute(0)"
      >
        <chart-card
          class="topcard"
          title="待审核订单"
          :total="waitAuditOrderCount"
        >
          <a-tooltip title="待审核订单" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
        </chart-card>
      </a-col>
      <a-col
        :sm="24"
        :md="12"
        :xl="6"
        :style="{ marginBottom: '24px' }"
        @click="HrefRoute(1)"
      >
        <chart-card
          class="topcard1"
          title="审核失败订单"
          :total="waitReplyCount"
        >
          <a-tooltip title="审核失败订单" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card
          class="topcard2"
          title="月销售额"
          :total="'￥' + salesAmount"
        >
          <a-tooltip title="本月销售额" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card class="topcard3" title="月销售量" :total="salesCount">
          <a-tooltip title="本月销售量" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
        </chart-card>
      </a-col>
    </a-row>
    <!-- 主题板块 -->
    <a-row :gutter="24">
      <!-- 左边 -->
      <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
        <!-- 统计柱状图 -->
        <a-card title :bordered="false">
          <a-tabs
            @change="callback"
            default-active-key="1"
            size="large"
            :tab-bar-style="{ marginBottom: '10px', paddingLeft: '16px' }"
          >
            <div class="extra-wrapper" slot="tabBarExtraContent">
              <div class="extra-item">
                <a @click="changeData_2(0)">本周</a>
                <a @click="changeData_2(1)">本月</a>
                <a @click="changeData_2(2)">本年</a>
              </div>
            </div>
            <a-tab-pane tab="销售统计" key="1">
              <a-row>
                <h-bar
                  :chartData="saleStatistics"
                  :chartSettings="saleStatisticsSettings"
                  @click="changeHadel"
                />
              </a-row>
            </a-tab-pane>
          </a-tabs>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import ChartCard from "@/components/ChartCard";
import Radar from "@/components/chart/Radar";
import HBar from "@/components/chart/Histogram";
import PipeBar from "@/components/chart/Pipe";
import RingBar from "@/components/chart/RingBar";
import { api } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";
import menuBus from "@/mixins/menuBus";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    ChartCard,
    Radar,
    HBar,
    PipeBar,
    RingBar,
  },
  data() {
    return {
      // 头部四小块
      salesCount: "0",
      waitReplyCount: "0",
      waitAuditOrderCount: "0",
      salesAmount: "0.00",
      // //环形图参数
      // RuningchartData: {
      //   columns: ["日期", "访问用户"],
      //   rows: [
      //     { 日期: "1/1", 访问用户: 1393 },
      //     { 日期: "1/2", 访问用户: 3530 },
      //     { 日期: "1/3", 访问用户: 2923 },
      //     { 日期: "1/4", 访问用户: 1723 },
      //     { 日期: "1/5", 访问用户: 3792 },
      //     { 日期: "1/6", 访问用户: 4593 }
      //   ]
      // },
      //柱状图参数
      extend: {
        series: {
          label: { show: true, position: "top" },
        },
      },
      // 折线图参数
      chartExtend: {
        series: {
          smooth: false,
        },
      },
      saleStatisticsSettings: {
        axisSite: { right: ["销售额"] },
        yAxisType: ["normal", "normal"],
        yAxisName: ["销售量", "销售额"],
      },
      saleStatistics: {
        columns: ["日期", "订单量", "销售额", "销售量"],
        rows: [],
      },
      //快捷键
      shortcuts: [],
      loading: true,
      current: 1,
    };
  },
  created() {
    setTimeout(() => {
      this.loading = !this.loading;
    }, 1000);
  },
  async mounted() {
    if (this.userData && this.userData.userId > 0) {
      this.getStatisticsInfo();
      this.getWorkBenchSalesInfoList(0);
    }
  },
  methods: {
    async getStatisticsInfo() {
      let data = await api.GetWorkBenchStatisticsInfo();
      if (data) {
        this.salesCount = data.salesCount + "";
        this.waitReplyCount = data.waitReplyCount + "";
        this.waitAuditOrderCount = data.waitAuditOrderCount + "";
        this.salesAmount = this.formatMoney(data.salesAmount) + "";
      }
    },
    HrefRoute(data) {
      if (data == 0) {
        this.$router.push({ path: "/Orders/OrderMaster/AuditList/list" });
      } else if (data == 1) {
        this.$router.push({
          path: "/Orders/OrderMaster/List/List",
          query: { status: 8 },
        });
      }
    },
    async getWorkBenchSalesInfoList(type) {
      let data = await api.GetWorkBenchSalesInfoList({ type: type });
      if (data) {
        this.saleStatistics.rows = [];

        data.forEach((a) => {
          this.saleStatistics.rows.push({
            日期:
              type == 0
                ? this.formatDate(a.date, "dddd")
                : type == 2
                ? this.formatDate(a.date, "MMMM")
                : this.formatDate(a.date, "MM-DD"),
            销售额: this.formatMoney(a.salesAmount) + "",
            销售量: a.salesCount + "",
            订单量: a.orderCount + "",
          });
        });
      }
      console.log(this.saleStatistics.rows);
    },
    setShortcuts() {},
    tagClick(tag) {
      console.log(tag);
      menuBus.$emit("checkmenu", [tag.moduleName], [tag.name]);
    },

    //折线图点击事件
    changeHadel(op) {
      console.log(op);
    },

    changedel(index, val) {
      this.tags[index].flag = val;
    },
    callback(key) {
      this.current = key;
    },
    async changeData_1(type) {},
    async changeData_2(type) {
      await this.getWorkBenchSalesInfoList(type);
    },
  },
};
</script>
<style  scoped>
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;
}
.extra-wrapper .extra-item {
  display: inline-block;
  margin-right: 24px;
}

.ant-tag {
  margin-bottom: 8px;
  margin-bottom: 8px;
  color: #fff;
  background: rgb(43, 152, 255);
  border: #fff;
  padding: 5px;
  height: 31px;
  line-height: 20px;
}
.ant-tag a {
  width: 75px !important;
  color: #fff !important;
  text-align: center !important;
}
.extra-wrapper a {
  margin-left: 24px;
}
.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;
}
.item-group a {
  color: rgba(0, 0, 0, 0.65);
  display: inline-block;
  font-size: 14px;
  margin-bottom: 13px;
  width: 25%;
}
.topcard {
  background: -webkit-linear-gradient(
    to right,
    rgb(250, 149, 157),
    rgb(253, 95, 118)
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    to right,
    rgb(250, 149, 157),
    rgb(253, 95, 118)
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    to right,
    rgb(250, 149, 157),
    rgb(253, 95, 118)
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, rgb(250, 149, 157), rgb(253, 95, 118));
}
.topcard1 {
  background: -webkit-linear-gradient(
    to right,
    rgb(248, 207, 145),
    rgb(250, 184, 87)
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    to right,
    rgb(248, 207, 145),
    rgb(250, 184, 87)
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    to right,
    rgb(248, 207, 145),
    rgb(250, 184, 87)
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, rgb(248, 207, 145), rgb(250, 184, 87));
}

.topcard2 {
  background: -webkit-linear-gradient(
    to right,
    rgb(144, 196, 254),
    rgb(24, 144, 255)
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    to right,
    rgb(144, 196, 254),
    rgb(24, 144, 255)
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    to right,
    rgb(144, 196, 254),
    rgb(24, 144, 255)
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, rgb(144, 196, 254), rgb(24, 144, 255));
}

.topcard3 {
  background: -webkit-linear-gradient(
    to right,
    rgb(130, 228, 237),
    rgb(60, 202, 214)
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    to right,
    rgb(130, 228, 237),
    rgb(60, 202, 214)
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    to right,
    rgb(130, 228, 237),
    rgb(60, 202, 214)
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, rgb(130, 228, 237), rgb(60, 202, 214));
}
</style>





// WEBPACK FOOTER //
// src/router/workbench/index.vue